module.exports = __webpack_public_path__ + "static/img/p_10.1a5b717.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/p_10.jpg
// module id = 3K10
// module chunks = 9